const View = require("presto-ui").baseView;

class Home2 extends View {

	constructor(props, children, state) {
		super(props, children, state);
		this.shouldCacheScreen = false;

		document.title = "Juspay University";

		var link=document.createElement('meta');
  		link.name="description";
  		link.content="We want to enable you to become a Product Maker. Join us to learn Functional Programming, Category Theory and Product Design. Start creating scalable, real-world applications while still studying.";
  		document.getElementsByTagName('head')[0].appendChild(link);

		this.setIds(['Content']);

		this.style_RegisterText = {
			onClick: this.onClickRegister.bind(this)
		}

		this.style_ForumText = {
			onClick: this.onClickForum.bind(this)
		}

		this.style_LetsStartGroup = {
			onClick: this.onClickLetsStart.bind(this)
		}

		this.style_Jump_in___get_starte = {
			onClick: this.onClickLetsStart.bind(this)
		}

		this.style_LearnPrestoText = {
			onClick: this.onClickPresto.bind(this)
		}

		this.style_LetsStartFooterGroup = {
			onClick: this.onClickLetsStart.bind(this)
		}

		this.style_HeroVideoGroup = {
			onClick: this.onClickVideo.bind(this)
		}
	}

	onClickLetsStart(){
		var cmd = this.cmd({id : this.idSet.Content, visibility: "gone"});
		Android.runInUI(cmd,null);
		document.getElementById("content").scrollTo(0,0);

		if (window.__WIDTH <=600)
			window.__duiShowScreen(null,{screen:"MobileSFP"});
		else
			window.__duiShowScreen(null,{screen:"SFP"});
	}

	onClickRegister() {
		window.open("https://form.jotform.co/73251234628858",'_blank');
	}

	onClickForum() {
		window.open("https://muut.com/purescript-presto",'_blank');
	}

	onClickPresto() {
		var cmd = this.cmd({id : this.idSet.Content, visibility: "gone"});
		Android.runInUI(cmd,null);
		document.getElementById("content").scrollTo(0,0);

		if (window.__WIDTH <=600)
			window.__duiShowScreen(null,{screen:"MobilePresto"});
		else
			window.__duiShowScreen(null,{screen:"Presto"});
	}

	onClickVideo() {
		window.open("https://www.youtube.com/watch?v=ffzzXQI_i5s&feature=youtu.be",'_blank');
	}	

}

module.exports = Home2;



// WEBPACK FOOTER //
// ./controller/pages/Main/Home2.js